module.exports = __webpack_public_path__ + "media/icons/przebieg@3x-f04dc00c.svg";